import gql from "graphql-tag";

export const MY_TIMESHEET_UPDATE_COST = gql`
  mutation updateMySheetCost(
    $_id: String!
    $name: String!
    $color: String
    $value: Float!
    $billable: Boolean!
    $description: String!
    $validFrom: Date
    $validTo: Date
  ) {
    updateMySheetCost(
      _id: $_id
      name: $name
      color: $color
      value: $value
      billable: $billable
      description: $description
      validFrom: $validFrom
      validTo: $validTo
    ) {
      _id
      name
      description
      color
      validFrom
      validTo
      createdAt
      createdBy
      modifiedAt
      modifiedBy
      isDeleted
    }
  }
`;
